import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import { OnboardingInvite } from 'src/api/onboardingInvites';

export const useCreateOnboardingInvite = () => {
  const queryClient = useQueryClient();

  const {
    mutateAsync,
    isPending: isLoading,
    error,
    reset,
  } = useMutation<{ data: OnboardingInvite }, Error, { email: string }>({
    mutationFn: ({ email }) => api.post<OnboardingInvite>('admin/onboarding-invites', { email }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'onboarding-invites'] });
    },
  });

  return { createInvite: mutateAsync, isLoading, error, reset };
};
